import { utils } from "../../Foundation";
const courseTemplate = {};

/** 
  * Create star svg image
  **/
courseTemplate.generateStars = (settings) => {
    let stars = ['star', 'star', 'star', 'star', 'star'];
    stars = stars.map((str, i) => {
        if(i < settings.rating.stars) {
            str += ' fill';
        }
        let span = `<div class="${str}"></div>`;

        return span;
    }).join('');

    return stars;
}

/** 
  * Create video progress bar
  **/
courseTemplate.generateProgress = (refs, settings, isListView) => {
    let cssElem = 'width';
    if(isListView) {
        cssElem = 'height';
    }
    let progressClass = 'video-thumbnail';
    let progressLabel = refs.settings.translations.startCourse;
    if(settings.duration.time !== 0) {
        if(settings.course.progress >= settings.duration.time - 1) {
            // Complete course
            progressClass = 'video-thumbnail replay';
            progressLabel = refs.settings.translations.replayCourse;
        } else if(settings.course.progress > 0) {
            // Active course
            progressClass = 'video-thumbnail continue';
            progressLabel = refs.settings.translations.resumeCourse;
        }
    }
    // calculate length of pregress bar
    const progressLength = Math.ceil((Math.ceil(settings.course.progress) / Math.ceil(settings.duration.time))* 100);
    let progressStyling = progressLength > 0 ? `style='${cssElem}:${progressLength}%;'` : '';
    let progressBar = progressLength > 0 ? `show` : '';

    // If course is failed
    if(settings.failTag && settings.failTag.isFail) {
        // Play button
        progressClass = 'video-thumbnail';
        progressLabel = settings.failTag.label;
        // Progress bar
        progressStyling = `style='${cssElem}:100%;'`;
        progressBar = 'show fail';
    }

    return  {progressLabel, progressStyling, progressClass, progressBar}
}

/** 
  * Create grid view
  **/
courseTemplate.generateGridView = (settings) => {
    let ratingTemp = settings.stars || settings.share || settings.bookmark ? `
        <div class="card-rating d-flex align-items-center">
            ${settings.stars ? `<div class="card-stars d-flex">${settings.stars}</div>` : ''}
            <div class="card-icons d-flex">
                ${settings.share ? `<div class="btn-icon person" title="${settings.share.label}"></div>` : ''}
                ${settings.bookmark ? `<div class="btn-icon ${settings.bookmark.class}" title="${settings.bookmark.label}"></div>` : ''}
            </div>
        </div>
    ` : '';

    // Create label for the course
    let courseLabel = '';
    if(settings.failTag && settings.failTag.isFail) {
        // Failed course label
        courseLabel = `<div class="course__label course__label-fail">${settings.failTag.label}</div>`
    } else if(settings.newTag.isNew) {
        // New course label
        courseLabel = `<div class="course__label course__label-new">${settings.newTag.label}</div>`;
    };

    let pointTemp = settings.points ? `
        <div class="card-points d-flex">
            <div class="btn-icon award"></div>
            <p>${settings.points.label}: ${settings.points.points}</p>
        </div>
    ` : '';

    return `
        <div class="card d-flex justify-content-between">
            <div class="card-top">
                <div class="card-image d-flex" style="background-image: url('${settings.image.url}');" aria-label="${settings.image.alt}">
                    ${courseLabel}
                    <div class="my_progress ${settings.progress.progressBar}">
                        <div class="progress_indicator" ${settings.progress.progressStyling}></div>
                    </div>
                </div>
                <div class="card-body">
                    ${ratingTemp}
                    <div class="card-info">
                        <div class="card-duration d-flex">
                            <div class="btn-icon clock"></div>
                            <span>${settings.duration.label}: ${settings.duration.time} ${settings.duration.timeLabel}</span> 
                        </div>
                        ${pointTemp}
                    </div>
                    <div class="card-title h5" aria-role="heading" aria-level="3">${settings.content.headline}</div>
                    <p class="card-text">${settings.content.description}</p>
                </div>
            </div>
            <div class="card-bottom">
                <div class="card-footer">
                    ${settings.readMore.url ? `<a href="${settings.readMore.url}" class="read-more cta-primary">${settings.readMore.label}</a>` : '<div data-info="Placeholder div to keep Play btn right"></div>'}
                    ${settings.course.url ? `
                        <div class="card_show_video" data-url="${settings.course.url}" tabindex="0" title="${settings.progress.progressLabel}">
                            <div class="${settings.progress.progressClass}"></div>
                        </div>`
                    : ''}
                </div>
            </div>
        </div>
    `;
}

/** 
  * Create list view
  **/
courseTemplate.generateListView = (settings) => {
    let ratingTemp = settings.stars || settings.share || settings.bookmark ? `
        <div class="card-rating d-flex align-items-center">
            ${settings.stars ? `<div class="card-stars d-flex">${settings.stars}</div>` : ''}
            <div class="card-icons d-flex">
                ${settings.share ? `<div class="btn-icon person" title="${settings.share.label}"></div>` : ''}
                ${settings.bookmark ? `<div class="btn-icon ${settings.bookmark.class}" title="${settings.bookmark.label}"></div>` : ''}
            </div>
        </div>
    ` : '';

    let courseLabel = '';
    if(settings.failTag && settings.failTag.isFail) {
        // Failed course label
        courseLabel = `<div class="course__label course__label-fail">${settings.failTag.label}</div>`
    } else if(settings.newTag.isNew) {
        // New course label
        courseLabel = `<div class="course__label course__label-new">${settings.newTag.label}</div>`;
    };

    let pointTemp = settings.points ? `
        <div class="card-points d-flex">
            <div class="btn-icon award"></div>
            <p>${settings.points.label}: ${settings.points.points}</p>
        </div>
    ` : '';

    return `
        <div class="card d-flex justify-content-between">
            <div class="card-top">
                <div class="card-image d-flex" style="background-image: url('${settings.image.url}');" aria-label="${settings.image.alt}">
                    ${courseLabel}
                    <div class="my_progress ${settings.progress.progressBar}">
                        <div class="progress_indicator" ${settings.progress.progressStyling}></div>
                    </div>
                </div>
            </div>
            <div class="card-bottom d-flex flex-direction-column">
                <div class="card-body">
                    ${ratingTemp}
                    <div class="card-info">
                        <div class="card-duration d-flex">
                            <div class="btn-icon clock"></div>
                            <span>${settings.duration.label}: ${settings.duration.time} ${settings.duration.timeLabel}</span> 
                        </div>
                        ${pointTemp}
                    </div>
                    <div class="card-title">${settings.content.headline}</div>
                    <p class="card-text">${settings.content.description}</p>
                </div>
                <div class="card-footer">
                    ${settings.readMore.url ? `<a href="${settings.readMore.url}" class="read-more cta-primary">${settings.readMore.label}</a>` : ''}
                    ${settings.course.url ? `
                        <div class="card_show_video" data-url="${settings.course.url}" tabindex="0" title="${settings.progress.progressLabel}">
                            <div class="${settings.progress.progressClass}"></div>
                        </div>`
                    : ''}
                </div>
            </div>
        </div>
    `;
}

courseTemplate.generateNoItemView = (message) => {
    return `
        <div class="d-flex justify-content-center align-items-center noItems">
            <h2>${message}</h2>
        </div>
    `;
}

courseTemplate.clearAllButton = (parentElement, label) => {
    const buttonDiv = utils.createElement('div', {
        'class': 'btn-clear-all',
        'tabindex': '0'
    }, parentElement);
    utils.createElement('i', {
        'class': 'eva eva-close-circle-outline',
    }, buttonDiv)
    utils.createElement('p', {
        'title': label,
        'innerText': label
    }, buttonDiv)

    return buttonDiv;
}

courseTemplate.filterLabel = (oList, filter, clearText) => {
    const listItem = utils.createElement('li', {
        'class': 'product-filter__list-item',
        'title': filter,
        'innerText': filter,
        'data-value': filter,
        'tabindex': '0'
    }, oList);
    const listIcon = utils.createElement('i', {
        'class': 'eva eva-close-circle-outline',
        'title': `${clearText} ${filter}`,
        'data-value': filter
    }, listItem)

    return [listItem, listIcon];
}

export { courseTemplate };